import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { PropertyProviderCategoryModel } from '../models/property-provider-category.model';
import { PropertyProviderCategoryService } from '../services/property-provider-category.service';

@Injectable()
export class PropertyProviderCategoryResolver implements Resolve<PropertyProviderCategoryModel> {

  constructor(private service: PropertyProviderCategoryService) 
  {

  }

  resolve(route: ActivatedRouteSnapshot): Observable<PropertyProviderCategoryModel> {
      return this.service.GetProviderCategory(route.params.property_provider_category_id);
  }
}
